import { useState } from "react";
import { toast } from "sonner";
import { CalendarClock, Loader2 } from "lucide-react";
import { api, formatErr } from "@/lib/api";

const toLocal = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
const fmt = (s) => new Date(s).toLocaleString("de-DE", { weekday: "short", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

export function QuestEndEdit({ q, onDone }) {
  const [val, setVal] = useState(toLocal(new Date(q.end)));
  const [busy, setBusy] = useState(false);
  const save = async (date) => {
    setBusy(true);
    try { const { data } = await api.put("/admin/quest/end", { end: date.toISOString() }); toast.success(`Neues Ende: ${fmt(data.end)} Uhr`); onDone(); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  const plus = (days) => save(new Date(new Date(q.end).getTime() + days * 86400000));
  return (
    <div className="rounded-2xl border border-red-100 bg-white p-4 space-y-3" data-testid="admin-quest-end-edit">
      <p className="text-sm font-bold flex items-center gap-1.5"><CalendarClock className="w-4 h-4 text-rose-500" /> Laufzeit ändern</p>
      <p className="text-xs text-slate-500">Aktuelles Ende: <b data-testid="admin-quest-end-current">{fmt(q.end)} Uhr</b></p>
      <div className="flex flex-wrap gap-2">
        {[[1, "+1 Tag"], [3, "+3 Tage"], [7, "+1 Woche"]].map(([d, l]) => (
          <button key={d} onClick={() => plus(d)} disabled={busy} data-testid={`admin-quest-end-plus-${d}`} className="h-9 px-4 rounded-full border-2 border-rose-200 text-rose-600 text-sm font-bold hover:bg-rose-50 active:scale-95 transition-transform">{l}</button>
        ))}
      </div>
      <div className="flex gap-2">
        <input type="datetime-local" value={val} onChange={(e) => setVal(e.target.value)} data-testid="admin-quest-end-input" className="flex-1 min-w-0 h-10 px-3 rounded-xl border border-pink-100 text-sm focus:outline-none focus:ring-2 focus:ring-rose-200" />
        <button onClick={() => save(new Date(val))} disabled={busy || !val} data-testid="admin-quest-end-save" className="h-10 px-4 rounded-full pink-gradient text-white text-sm font-bold inline-flex items-center gap-1.5 shrink-0">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Speichern
        </button>
      </div>
      <p className="text-xs text-slate-400">Du kannst das Ende verlängern oder verkürzen (mind. 5 Minuten ab jetzt, max. 60 Tage).</p>
    </div>
  );
}
